import {FlatListProps} from 'react-native';
import {FarmLogEntity} from '../Notifications';

export type ListProps = FlatListProps<FarmLogEntity>;

export const keyExtractor: ListProps['keyExtractor'] = (item) => item.id;
